import React, { useState, useEffect } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";


const MultiSelect = ({ options, onChange, selectedValue }) => {
    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        if (sessionStorage.selectedplaza)
            setSelectedOptions(options.filter(option =>
                selectedValue.toString().split(",").includes(option.value)
            ));
        else
            setSelectedOptions([{ label: "All", value: "*" }, ...options]);
    }, [options]);

    function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
        if (value && value.some((o) => o.value === "*")) {
            return `${placeholderButtonLabel}: All`;
        } else {
            return `${placeholderButtonLabel}: ${value.length} selected`;
        }
    }

    function onChangeHandler(value, event) {
        if (event.action === "select-option" && event.option.value === "*") {
            this.setState(this.options);
            onChange(this.options.map((e => e.value)));
        } else if (
            event.action === "deselect-option" &&
            event.option.value === "*"
        ) {
            this.setState([]);
            onChange([].map((e => e.value)));
        } else if (event.action === "deselect-option") {
            this.setState(value.filter((o) => o.value !== "*"));
            onChange(value.filter((o) => o.value !== "*").map((e => e.value)));
        } else if (value.length === this.options.length - 1) {
            this.setState(this.options);
            onChange(this.options.map((e => e.value)));
        } else {
            this.setState(value);
            onChange(value.map((e => e.value)));
        }
    }

    return (
        <ReactMultiSelectCheckboxes
            options={options}
            placeholderButtonLabel="Plaza"
            getDropdownButtonLabel={getDropdownButtonLabel}
            value={selectedOptions}
            onChange={onChangeHandler}
            setState={setSelectedOptions}
            className="multi-select-plaza"
        />
    );
};

export default MultiSelect;